import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lighting",
  "use": "icon-lighting-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-lighting\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<polygon points=\"12.63 10.75 17 10.75 11.38 18.88 11.38 13.25 7 13.25 12.63 5.13 12.63 10.75\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol